import { render, staticRenderFns } from "./gj-button.vue?vue&type=template&id=4a567946&scoped=true&"
import script from "./gj-button.vue?vue&type=script&lang=js&"
export * from "./gj-button.vue?vue&type=script&lang=js&"
import style0 from "./gj-button.vue?vue&type=style&index=0&id=4a567946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a567946",
  null
  
)

export default component.exports